import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SimpleDialogConfig } from '../simple-dialog/simple-dialog.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MarkdownComponent, MarkdownModule } from 'ngx-markdown';
import { AntButtonModule } from '@antony/ng-ui';
import { TranslatePipe } from '@ngx-translate/core';

export interface MarkdownDialogConfig extends SimpleDialogConfig {
  messageData?: any;
}

@Component({
  selector: 'app-markdown-dialog',
  templateUrl: './markdown-dialog.component.html',
  styleUrls: ['./markdown-dialog.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MarkdownComponent, MatDialogActions, AntButtonModule, TranslatePipe],
})
export class MarkdownDialogComponent {
  public readonly data: Required<MarkdownDialogConfig>;

  constructor(
    private matDialogRef: MatDialogRef<MarkdownDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: MarkdownDialogConfig
  ) {
    this.data = {
      dismissActionName: 'NO',
      submitActionName: 'YES',
      messageData: {},
      ...data,
    };
  }

  dismiss() {
    this.matDialogRef.close(false);
  }

  submit() {
    this.matDialogRef.close(true);
  }
}
